import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "paginator" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["disabled"]

import { computed } from "vue";
import IconChevronLeft from "@/assets/icons/IconChevronLeft.vue";
import IconChevronRight from "@/assets/icons/IconChevronRight.vue";
import type {Paginator} from "@/types/paginator";

interface PaginatorProps {
  paginator: Paginator;
}

interface PaginatorEmits {
  (_e: "goToPage", _page: number): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Paginator',
  props: {
    paginator: {}
  },
  emits: ["goToPage"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// Текущая страница из пагинатора
const currentPage = computed(() => props.paginator.current_page ?? 1);
// Общее количество страниц
const totalPages = computed(() => props.paginator.total_pages);

// Вычисляемое свойство для генерации массива отображаемых страниц
const visiblePages = computed<(number | string)[]>(() => {
  const pages: (number | string)[] = [];
  const current: number = currentPage.value;
  const total: number = totalPages.value;

  // Если страниц мало (до 9), показываем все
  if (total <= 9) {
    for (let i = 1; i <= total; i++) {
      pages.push(i);
    }
    return pages;
  }

  // Всегда показываем первые 3 страницы
  pages.push(1, 2, 3);

  // Определяем, нужно ли показывать среднюю часть с активной страницей
  if (current > 5 && current < total - 4) {
    // Активная страница в середине
    // Показываем: 1 2 3 ... prev current next ... 18 19 20
    pages.push("...");
    pages.push(current - 1, current, current + 1);
    pages.push("...");
  } else if (current === 5) {
    // Активная страница 5 - нужно показать страницу 4 и 6
    // Показываем: 1 2 3 4 5 6 ... 18 19 20
    pages.push(4, 5, 6);
    pages.push("...");
  } else if (current >= 3 && current < 5) {
    // Активная страница между началом и серединой (3-4)
    // Показываем страницы от 4 до 5, чтобы показать соседей
    for (let i = 4; i <= 5; i++) {
      if (!pages.includes(i)) {
        pages.push(i);
      }
    }
    pages.push("...");
  } else if (current >= total - 4) {
    // Активная страница ближе к концу
    // Показываем: 1 2 3 ... последние 6 страниц
    pages.push("...");
  } else {
    // Активная страница 1-2 (уже в первых трёх)
    pages.push("...");
  }

  // Всегда показываем последние 3 страницы
  // Если активная близка к концу, показываем больше
  if (current >= total - 4) {
    for (let i = total - 5; i <= total; i++) {
      if (!pages.includes(i) && i > 3) {
        pages.push(i);
      }
    }
  } else {
    pages.push(total - 2, total - 1, total);
  }

  return pages;
});

const goToPreviousPage = () => {
  if (currentPage.value > 1) {
    emit("goToPage", currentPage.value - 1);
  }
};

const goToNextPage = () => {
  if (currentPage.value < totalPages.value) {
    emit("goToPage", currentPage.value + 1);
  }
};

const goToPage = (page: number | string) => {
  if (typeof page === "number") {
    emit("goToPage", page);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      disabled: !__props.paginator.previous_page,
      class: "paginator__button",
      onClick: goToPreviousPage
    }, [
      _createVNode(IconChevronLeft)
    ], 8, _hoisted_2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["paginator__item", {
        'paginator__item--active': currentPage.value === item,
        'paginator__item--dots': item === '...'
      }]),
        onClick: ($event: any) => (goToPage(item))
      }, _toDisplayString(item), 11, _hoisted_3))
    }), 128)),
    _createElementVNode("button", {
      class: "paginator__button",
      disabled: !__props.paginator.next_page,
      onClick: goToNextPage
    }, [
      _createVNode(IconChevronRight)
    ], 8, _hoisted_4)
  ]))
}
}

})